import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["customerSelect", "receiptSelect", "receiptsList"]

  loadReceipts(event) {
    const customerId = this.customerSelectTarget.value

    fetch(`/receipts/for_customer/${customerId}`, {
      headers: { "Accept": "application/json" }
    })
      .then(response => response.json())
      .then(data => {
        console.log("Data received:", data);
        this.updateReceiptOptions(data);
      })
      .catch(error => {
        console.error("Fetch error:", error);
      });
  }

  updateReceiptOptions(receipts) {
    console.log("Updating receipts:", receipts); // Füge das hinzu
    this.receiptSelectTarget.innerHTML = "";

    receipts.forEach(receipt => {
      const option = document.createElement("option");
      option.value = receipt.id;
      option.textContent = receipt.subject;
      this.receiptSelectTarget.appendChild(option);
    });
  }
}